// Mirrors the CAMPAIGN_OPPORTUNITY_SKIPPED_REASON_* / CAMPAIGN_CONTACT_SKIPPED_REASON_*
// constants in the Go backend (api/core/campaign_opportunities.go +
// campaign_contacts.go). Explains why a campaign recipient was skipped at send time.
enum CampaignOpportunitySkippedReason {
    Undefined = 0,
    MarketingOptOut = 1,
    InvalidEmailAddress = 2,
    InvalidName = 3,
    LinkedToContact = 4,
    OpportunityNotActive = 5,
}

export const CampaignOpportunitySkippedReasonLabels: { [key: number]: string } = {
    [CampaignOpportunitySkippedReason.MarketingOptOut]: 'Prospect has not agreed to marketing',
    [CampaignOpportunitySkippedReason.InvalidEmailAddress]: 'No / invalid email address',
    [CampaignOpportunitySkippedReason.InvalidName]: 'Missing contact name',
    [CampaignOpportunitySkippedReason.LinkedToContact]: 'Now linked to a contact',
    [CampaignOpportunitySkippedReason.OpportunityNotActive]: 'Opportunity is no longer active (won, lost or closed)',
};

export function campaignOpportunitySkippedReasonLabel(reason: number): string {
    return CampaignOpportunitySkippedReasonLabels[reason] || '';
}

export default CampaignOpportunitySkippedReason;
